import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseCodeitemEditorComponent } from '../codeitem-base/codeitem-base.component';
import { CodeItemService } from '../../common/services/codeitem.service';

@Component({
  selector: 'prg-codeitem-loop',
  templateUrl: './codeitem-loop.component.html',
  styleUrls: ['./codeitem-loop.component.css']
})
export class CodeitemLoopComponent extends BaseCodeitemEditorComponent implements OnInit {

  constructor(
    store: Store<any>,
    router: Router,
    route: ActivatedRoute,
    codeitemService: CodeItemService) {
    super(store, router, route, codeitemService);


    store.select(s => s.advancedProgramming.device).subscribe(
      device => {
        if (device) {
          router.navigate(['../loop'], { relativeTo: route });
        }
      });
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/codeitem-loop/codeitem-loop.component.ts